import { cn, linkVariants } from '@seen/ui'
import type { ElementRef } from 'react'
import { Link, type LinkProps } from '#src/components/core/Link.tsx'
import { forwardRef } from '#src/utils/forwardRef.ts'

export type TextLinkProps = LinkProps

export const TextLink = forwardRef<ElementRef<typeof Link>, TextLinkProps>(
  ({ className, ...delegated }, ref) => (
    <Link
      ref={ref}
      className={cn(linkVariants({ className }))}
      {...delegated}
    />
  )
)
